import { Component, ViewEncapsulation, Inject, PLATFORM_ID, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { FormGroup, Validators, FormControl, FormArray, FormBuilder } from '@angular/forms';
import { Unit } from '../../models/unit.model';

@Component({
  selector: 'nominative-voucher',
  templateUrl: './nominative-voucher.component.html',
  styleUrls: ['./nominative-voucher.component.scss', '../../../assets/css/form.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NominativeVoucherComponent implements OnInit {

  public isNode: boolean;
  public formGroup: FormGroup;
  public items: FormArray;
  public stepValidForms: Object[];

  @Input() unit: Unit[];
  @Input() step: number;
  @Output() validFormNominativeVoucher: EventEmitter<FormArray> = new EventEmitter();

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private formBuilder: FormBuilder){
    this.isNode = isPlatformServer(this.platformId);
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      items: this.formBuilder.array([])
    });

    for (let i = 0; i < this.unit.length; i++) {
      this.addItem(this.unit[i]);
    }

    this.stepValidForms = this.formGroup.get('items')['controls'].map((data, i) => {
      return {step: i + 1, formValid: data.valid};
    });

    this.formGroup.get('items').statusChanges.subscribe(form => {
        this.validFormNominativeVoucher.emit(this.items);
    });
  }

  ngOnChanges(changes:SimpleChanges) {
    if (changes.step && this.formGroup && this.stepValidForms) {
      let previousStepArray = changes.step.previousValue - 1;
      if (this.formGroup.get('items')['controls'][previousStepArray].valid) {
        this.stepValidForms[previousStepArray]['formValid'] = true;
      } else {
        this.stepValidForms[previousStepArray]['formValid'] = false;
      }
    }
  }

  createFormGroup(unit): FormGroup {
    return this.formBuilder.group({
      name: new FormControl ('', [Validators.compose([Validators.required, Validators.max(100), Validators.pattern('^([^0-9]*)$')])]),
      surname: new FormControl ('', [Validators.compose([Validators.required, Validators.max(100), Validators.pattern('^([^0-9]*)$')])]),
      idCard: new FormControl ('', [Validators.required]),
      personType: new FormControl(unit.person)
    });
  }

  addItem(unit): void {
    this.items = this.formGroup.get('items') as FormArray;
    this.items.push(this.createFormGroup(unit));
  }

}